import { useEffect } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.dataset.jsonld = 'true';
    document.head.appendChild(script);
    return () => {
      document.head.querySelectorAll('script[data-jsonld="true"]').forEach((s) => s.remove());
    };
  }, [JSON.stringify(data)]);
  return null;
}